//Used in productAPI.js
export const transformType = (type) => {
  switch (type) {
    case "vouchersqr":
      return "vouchers/QR";
    case "vouchersext":
      return "vouchers/EXT";
    case "vouchersint":
      return "vouchers/INT";
    case "promoprefixes":
      return "promoPrefixes";
    case "producttypeenums":
      return "typeEnums";
    case "events":
      return "event";
    default:
      return type;
  }
};

//Used in Product.js
export const transformActiveType = (activeType) => {
  switch (activeType) {
    case "vouchersqr":
      return "vouchers/QR";
    case "vouchersext":
      return "vouchers/EXT";
    case "vouchersint":
      return "vouchers/INT";
    case "promoprefixes":
      return "promoPrefixes";
    case "producttypeenums":
      return "typeEnums";
    case "events":
      return "event";
    default:
      return activeType;
  }
};

//Used in Product.js
//FOR VISUAL PURPOUSE ONLY
export const transformActiveTypeText = (activeType) => {
  switch (activeType) {
    case "products":
      return "Products";
    case "missions":
      return "Missions";
    case "vouchersqr":
      return "Vouchers Machine";
    case "vouchersext":
      return "Vouchers Ext";
    case "vouchersint":
      return "Vouchers Sap";
    case "promoprefixes":
      return "Promo Prefixes";
    case "producttypeenums":
      return "Type enums";
    case "events":
      return "Events";
    default:
      return activeType;
  }
};
